import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, User } from 'lucide-react';
import { Button } from './ui/button';
import ktcLogo from '../assets/ktc.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Beranda', href: '#beranda' },
    { name: 'Layanan', href: '#layanan' },
    { name: 'Paket', href: '#paket' },
    { name: 'Tentang Kami', href: '#tentang' },
    { name: 'Berita', href: '#berita' },
    
    
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'glass py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="#beranda" 
            onClick={(e) => { e.preventDefault(); scrollToSection('#beranda'); }}
            className="flex items-center gap-3"
            data-testid="nav-logo"
          >
            <img 
              src={ktcLogo}
              alt="KTC Logo" 
              className="h-10 w-auto"
            />
            <span className="font-outfit font-bold text-lg text-white hidden sm:block">
              Kedai Teknologi Celebes
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="nav-link text-sm font-medium text-gray-300 hover:text-white transition-colors"
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-3">
            <Link to="/portal/login">
              <Button 
                className="btn-primary px-4 py-2 rounded-full text-white font-medium"
                data-testid="nav-portal-button"
              >
                <User className="w-4 h-4 mr-2" />
                Portal Pelanggan
              </Button>
            </Link>
            <Button 
              className="btn-primary px-6 py-2 rounded-full text-white font-medium"
              data-testid="nav-cta-button"
              onClick={() => scrollToSection('#kontak')}
            >
              Hubungi Kami
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-4 pb-4 border-t border-white/10"
          >
            <div className="flex flex-col gap-4 pt-4">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  className="text-left text-gray-300 hover:text-white transition-colors py-2"
                  data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  {link.name}
                </button>
              ))}
              <Link to="/portal/login" className="w-full">
                <Button 
                  className="btn-primary w-full mt-2 rounded-full text-white font-medium"
                >
                  <User className="w-4 h-4 mr-2" />
                  Portal Pelanggan
                </Button>
              </Link>
              <Button 
                className="btn-primary w-full mt-2 rounded-full text-white font-medium"
                onClick={() => scrollToSection('#kontak')}
              >
                Hubungi Kami
              </Button>
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;

